export default "__VITE_ASSET__7b3b0762__"